// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAL4IwIxycsoYEwdSH7GVIDtma-w9CYyPg",
  authDomain: "satsuma-f4c64.firebaseapp.com",
  projectId: "satsuma-f4c64",
  storageBucket: "satsuma-f4c64.firebasestorage.app",
  messagingSenderId: "672718706122",
  appId: "1:672718706122:web:974c9d0e5e5ce9cf00ab33",
  measurementId: "G-0MD4KXGZ1B"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
